<ion-list mode="ios" lines="none" style="width: max-content">
  <ng-container *ngFor="let data of list">
    <ion-item
      mode="md"
      lines="none"
      color="white"
      button
      detail="false"
      class="item-data"
      (click)="onSelect(data)"
    >
      <ion-icon
        *ngIf="data.icon"
        [name]="data.icon"
        slot="start"
        color="status-icon-enable"
        style="margin-right: 10px"
      ></ion-icon>
      <ion-label color="status-icon-enable">{{ data.name }}</ion-label>
    </ion-item>
  </ng-container>
</ion-list>
